<div>
  <div class="display-in-center sp-top-padding-50 sp-bottom-padding-10">
    <span class="Inter-Medium sp-font-size-28">
      Your product sent for
    </span>
  </div>
  <div class="display-in-center">
    <span class="Inter-Medium sp-font-size-28">
      review successfully
    </span>
  </div>
  <div class="display-in-center">
    <span class="Inter-Regular sp-font-size-16 sp-top-padding-20 sp-bottom-padding-3">
      Our team will take 3 to 5 days to review your
    </span>
  </div>
  <div class="display-in-center sp-bottom-padding-3">
    <span class="Inter-Regular sp-font-size-16">
      product and publish, you will be notified
    </span>
  </div>
  <div class="display-in-center sp-bottom-padding-20">
    <span class="Inter-Regular sp-font-size-16">
      about the progress.
    </span>
  </div>
  <hr class="hr-class">
  <div class="display-in-center sp-top-padding-15 pointer-class">
    <div class="btn" (click)="ok()">Ok, Got it.</div>
  </div>
</div>
